import template from './ws-input-pills.tmpl.html';
import controller from './ws-input-pills.controller';

const WsInputPillsComponent = {
  template,
  controller,
  bindings: {
    dismissText: '@?',
    placeholderText: '@',
    onModelChange: '&', // passes an array of pills and a pillInput string ({ pills, pillInput })
  },
};

export default WsInputPillsComponent;



// WEBPACK FOOTER //
// ./src/form/ws-input-pills/index.js